export type NbsYearRangeFilterProps = {
  readonly years: readonly number[];
  readonly fromYear: string;
  readonly toYear: string;
  /** Snapshot year for Donut / Radar — kept in range when from/to change. */
  readonly year?: string;
  readonly onChange: (patch: { fromYear?: string; toYear?: string; year?: string }) => void;
};

export function NbsYearRangeFilter({
  years,
  fromYear,
  toYear,
  year,
  onChange,
}: NbsYearRangeFilterProps) {
  const options = years.length ? years : [2005, 2015, 2025];
  return (
    <>
      <label htmlFor="nbs-filter-from-year">
        De
        <select
          id="nbs-filter-from-year"
          value={fromYear}
          onChange={(e) => {
            const nextFrom = e.target.value;
            const patch: { fromYear: string; toYear?: string; year?: string } = {
              fromYear: nextFrom,
            };
            if (Number(toYear) < Number(nextFrom)) patch.toYear = nextFrom;
            const effectiveTo = patch.toYear ?? toYear;
            const snap = year ?? effectiveTo;
            if (Number(snap) < Number(nextFrom) || Number(snap) > Number(effectiveTo)) {
              patch.year = effectiveTo;
            }
            onChange(patch);
          }}
        >
          {options.map((y) => (
            <option key={y} value={String(y)}>
              {y}
            </option>
          ))}
        </select>
      </label>
      <label htmlFor="nbs-filter-to-year">
        À
        <select
          id="nbs-filter-to-year"
          value={toYear}
          onChange={(e) => {
            const nextTo = e.target.value;
            const patch: { toYear: string; fromYear?: string; year?: string } = {
              toYear: nextTo,
              year: nextTo,
            };
            if (Number(fromYear) > Number(nextTo)) patch.fromYear = nextTo;
            onChange(patch);
          }}
        >
          {options.map((y) => (
            <option key={y} value={String(y)}>
              {y}
            </option>
          ))}
        </select>
      </label>
    </>
  );
}
